<template>
  <div class="invoice-preview">
    <spinner
      spinner
      class="spinner"
      line-fg-color="#00796b"
      :size="100"
      :line-size="6"
      v-if="isLoading"
    ></spinner>
    <div v-if="!isLoading">
      <div class="modal-header">
        <h2>Račun</h2>
      </div>
      <div class="invoice">
        <div class="info">
          <h4 class="title">
            <b>Podaci</b>
          </h4>
          <div class="data">
            <small>Broj računa</small>
            <h4>{{invoice.invoiceNumber}}</h4>
          </div>
          <div class="data">
            <small>Opis</small>
            <h4>{{invoice.description}}</h4>
          </div>
          <div class="data">
            <small>Obračunski period</small>
            <h4>{{invoice.accountingPeriod}}</h4>
          </div>
          <div class="data">
            <small>Rok plaćanja</small>
            <h4>{{invoice.paymentPeriod | formatDate}}</h4>
          </div>
          <div class="data">
            <small>Datum izdavanja</small>
            <h4>{{invoice.issueDate | formatDate}}</h4>
          </div>
          <div class="data">
            <small>Kreiran</small>
            <h4>{{invoice.timestamp | formatDate}}</h4>
          </div>
        </div>
        <div class="finances">
          <h4>
            <b class="title">Stanovi</b>
          </h4>
          <modal-finances-table class="invoice-table" :data="members" :columns="memberColumns"></modal-finances-table>
          <h4>
            <b class="title">Stavke računa</b>
          </h4>
          <modal-finances-table
            class="invoice-table"
            :data="invoice.invoiceItems"
            :columns="previewExpensesColumns"
          ></modal-finances-table>
          <h5 class="total">UKUPNO: {{ invoice.totalAmount | addSeparator }}</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger btn--mod" @click="closeModal">Nazad</button>
      </div>
    </div>
  </div>
</template>

<script>
import { financesInstance } from '@/axios/axios.js';
import { mapMutations, mapState } from 'vuex';
import ModalFinancesTable from '../ModalFinancesTable';
import { addSeparatorMixin, formatDateMixin } from '@/mixins/mixins.js';
export default {
  name: 'InvoicePreview',
  components: {
    ModalFinancesTable
  },
  created() {
    document.addEventListener('keydown', this.processKeyboardEvent);
    this.invoice = this.$store.state.modal.invoice;
    this.isLoading = true;
    financesInstance.get(`invoices/${this.invoice.id}`).then(({ data }) => {
      this.invoice = data.invoice;
      this.members = data.members;
      this.isLoading = false;
    });
  },
  mixins: [addSeparatorMixin, formatDateMixin],
  data() {
    return {
      isLoading: false,
      invoice: {
        invoiceItems: []
      },
      members: [],
      memberColumns: [
        { key: 'full_name', label: 'Ime i prezime', flex: 2 },
        { key: 'div_description', label: 'Opis', flex: 1 },
        { key: 'email', label: 'Email', flex: 2 }
      ],
      previewExpensesColumns: [
        { key: 'serialNumber', label: 'rBr', flex: 1 },
        { key: 'name', label: 'Stavka računa', flex: 2 },
        { key: 'quantity', label: 'Kolicina', flex: 2 },
        { key: 'price', label: 'Cena', flex: 2 },
        { key: 'total', label: 'Ukupno', flex: 2 }
      ],
      previewExpensesData: []
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.processKeyboardEvent);
  }
};
</script>

<style scoped lang="scss">
.invoice-preview {
  .spinner {
    padding: 10px 0;
  }
  .invoice {
    height: 50vh;
    max-height: 50vh;
    display: flex;
    padding: 1rem 0;

    .info {
      width: 43%;
      margin-right: 1rem;
      padding-right: 1rem;
      border-right: 1px solid #e9ecef;
    }

    .finances {
      width: 57%;
      display: flex;
      flex-direction: column;
      height: 100%;

      .invoice-table {
        height: calc(50% - 44px);
        max-height: calc(50% - 44px);
      }

      .total {
        text-align: right;
        font-weight: 900;
      }
    }

    .title {
      font-size: 18px;
      display: inline-block;
      border-bottom: 1px solid var(--primary-color);
      margin-bottom: 2px;
    }
  }
}

.btn--mod {
  margin: 0 auto;
}
</style>
